import Store, { action } from '../store';
import { IPart } from 'types';
import { SIGN_OUT_SUCCESS } from '../auth';
import { WATCH_PARTS, UPDATE_PART, REMOVE_PART } from './constants';

export default class PartStore extends Store {
  list: IPart[] = [];
  get(key: string): IPart {
    for (const p of this.list) {
      if (p.key === key) return p;
    }
  }

  @action(WATCH_PARTS)
  handleWatch() {
    this.list = [];
    this.emit();
  }

  @action(UPDATE_PART)
  handleUpdate(e, part: IPart) {
    this.list = Store.addOrReplace(this.list, part);
    this.emit();
  }

  @action(REMOVE_PART)
  handleRemove(e, key: string) {
    this.list = this.list.filter(p => p.key !== key);
    this.emit();
  }

  @action(SIGN_OUT_SUCCESS)
  handleSignout() {
    this.list = [];
    this.emit();
  }
}
